import React from 'react';
import _map from 'lodash/map';
import _times from 'lodash/times';
import classnames from 'classnames';

import { skeleton as Skeleton } from '@breezeway/brzw-components';
import { SKELETON_CLASS_NAME } from './constants';
import './service_summary_skeleton.scss';

const ServiceSummarySkeleton = () => {
  const { SKELETON_BAR_HEIGHTS, SKELETON_THEMES } = Skeleton.constants;
  const ROWS_NUMBER = 6;

  return (
    <div className={SKELETON_CLASS_NAME}>
      {_map(_times(ROWS_NUMBER, Number), value => (
        <div
          className={classnames(`${SKELETON_CLASS_NAME}__row`, {
            [`${SKELETON_CLASS_NAME}__row--with-spacing`]: value === 2,
          })}
          key={`service-summary-skeleton-${value}`}
        >
          <Skeleton.SkeletonBar
            className={`${SKELETON_CLASS_NAME}__label`}
            height={SKELETON_BAR_HEIGHTS.XXSMALL}
            theme={SKELETON_THEMES.WHISPER}
          />

          <div className={`${SKELETON_CLASS_NAME}__value-container`}>
            <Skeleton.SkeletonBar
              className={`${SKELETON_CLASS_NAME}__value`}
              height={SKELETON_BAR_HEIGHTS.XXSMALL}
              theme={SKELETON_THEMES.WHISPER}
            />
          </div>
        </div>
      ))}
    </div>
  );
};

export default ServiceSummarySkeleton;
